import React, { useState, useEffect, useRef } from 'react';
import { API, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';
import AuctionCountdown from './AuctionCountdown';
import TrustBadge from './TrustBadge';
import AuctionReviewModal from './AuctionReviewModal';
import AuctionEditModal from './AuctionEditModal';

// 내 활동 통합 — 3 서브탭 (내 출품 / 내 입찰 / 내 낙찰)
function AuctionMyActivity(props){
  var onViewAuction=props.onViewAuction;

  var[subTab,setSubTab]=useState('listings');
  var[items,setItems]=useState([]);
  var[loading,setLoading]=useState(true);
  var[error,setError]=useState('');
  var[cancelTarget,setCancelTarget]=useState(null); // {auctionId, bidCount, title}
  var[cancelSubmitting,setCancelSubmitting]=useState(false);
  var[cancelError,setCancelError]=useState('');
  var[reviewAuction,setReviewAuction]=useState(null);
  var[editAuction,setEditAuction]=useState(null);

  var loadData=function(tab){
    setLoading(true);
    setError('');
    var path=tab==='listings'?'/auctions/my-listings':tab==='bids'?'/auctions/my-bids':tab==='wins'?'/auctions/my-wins':'/auctions/my-favorites';
    var key=tab==='listings'?'listings':tab==='bids'?'bids':tab==='wins'?'wins':'favorites';
    authFetch(API+path)
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success&&d.data){
          setItems(d.data[key]||[]);
        }else{
          setItems([]);
          setError((d&&d.error)||'조회 실패');
        }
      })
      .catch(function(){setError('서버 연결 실패');setItems([])})
      .then(function(){setLoading(false)});
  };

  useEffect(function(){
    loadData(subTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[subTab]);

  // WebSocket 실시간 갱신 — 디바운스 500ms
  var fetchTimerRef=useRef(null);
  useEffect(function(){
    var s=getSocket();
    if(!s)return;
    var refresh=function(){
      if(fetchTimerRef.current)clearTimeout(fetchTimerRef.current);
      fetchTimerRef.current=setTimeout(function(){loadData(subTab)},500);
    };
    var events=['auction:new-listing','auction:bid-received','auction:winner-selected','auction:pending-selection','auction:expired','auction:cancelled','auction:rejected-all','auction:failed'];
    events.forEach(function(ev){s.on(ev,refresh)});
    return function(){
      events.forEach(function(ev){s.off(ev,refresh)});
      if(fetchTimerRef.current)clearTimeout(fetchTimerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[subTab]);

  var formatMan=function(won){return Math.round((won||0)/10000).toLocaleString()};

  var statusBadge=function(status){
    var m={
      active:{label:'입찰중',bg:'#eff6ff',fg:'#1B3A5C'},
      pending_selection:{label:'🏆 선택 대기',bg:'#fef3c7',fg:'#92400e'},
      sold:{label:'✓ 낙찰 완료',bg:'#d1fae5',fg:'#047857'},
      failed:{label:'유찰',bg:'#f1f5f9',fg:'#64748b'},
      rejected_all:{label:'전체 거절',bg:'#f1f5f9',fg:'#64748b'},
      expired_selection:{label:'선택 만료',bg:'#fef2f2',fg:'#dc2626'},
      cancelled:{label:'취소',bg:'#f1f5f9',fg:'#64748b'}
    };
    var b=m[status]||{label:status,bg:'#f1f5f9',fg:'#64748b'};
    return <span style={{padding:'3px 10px',background:b.bg,color:b.fg,borderRadius:4,fontSize:10,fontWeight:700}}>{b.label}</span>;
  };

  var askCancel=function(auction){
    setCancelError('');
    setCancelTarget({auctionId:auction.id,bidCount:(auction.liveStats&&auction.liveStats.bidCount)||0,title:(auction.car&&auction.car.model)||auction.title||''});
  };

  var unfavorite=function(auctionId){
    authFetch(API+'/auctions/'+auctionId+'/favorite',{method:'POST'})
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success){
          // 목록에서 즉시 제거 (낙관적)
          setItems(function(prev){return prev.filter(function(a){return a.id!==auctionId})});
        }
      })
      .catch(function(){});
  };

  var confirmCancel=function(){
    if(cancelSubmitting||!cancelTarget)return;
    setCancelSubmitting(true);
    setCancelError('');
    authFetch(API+'/auctions/'+cancelTarget.auctionId,{method:'DELETE'})
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success){
          setCancelTarget(null);
          loadData(subTab);
        }else{
          setCancelError((d&&d.error)||'취소 실패');
        }
      })
      .catch(function(){setCancelError('서버 연결 실패')})
      .then(function(){setCancelSubmitting(false)});
  };

  // ────────── 카드 렌더 ──────────

  var renderListingCard=function(a){
    var isActive=a.status==='active';
    var modelLabel=(a.car&&a.car.model)||a.title||'경매';
    var carNo=a.car&&a.car.number?a.car.number:'';
    return (
      <div key={a.id} style={{padding:'14px 16px',background:'#fff',border:'1px solid #e5e7eb',borderRadius:10,display:'flex',flexDirection:'column',gap:8}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:8}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:14,fontWeight:700,color:'#0f172a',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
              {modelLabel}{carNo?' · '+carNo:''}
            </div>
            <div style={{fontSize:11,color:'#64748b',marginTop:3}}>
              {'입찰 '+(a.liveBidCount||(a.liveStats&&a.liveStats.bidCount)||0)+'건'}
              {' · 조회 '+((a.liveStats&&a.liveStats.viewCount)||0)}
            </div>
          </div>
          {statusBadge(a.status)}
        </div>
        {isActive&&(
          <div style={{display:'flex',alignItems:'center',gap:6}}>
            <span style={{fontSize:11,color:'#64748b'}}>남은 시간</span>
            <AuctionCountdown timeRemaining={a.timeRemaining} size="sm"/>
          </div>
        )}
        <div style={{display:'flex',gap:6}}>
          <button onClick={function(){if(onViewAuction)onViewAuction(a.id)}}
            style={{flex:1,padding:'8px 0',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:700,cursor:'pointer'}}>
            상세보기
          </button>
          {a.status==='active'&&(a.liveBidCount||(a.liveStats&&a.liveStats.bidCount)||0)===0&&(
            <button onClick={function(){setEditAuction(a)}}
              style={{padding:'8px 14px',background:'#fff',color:'#1B3A5C',border:'1px solid #1B3A5C',borderRadius:6,fontSize:12,fontWeight:700,cursor:'pointer'}}>
              수정
            </button>
          )}
          {(a.status==='active'||a.status==='pending')&&(
            <button onClick={function(){askCancel(a)}}
              style={{padding:'8px 14px',background:'#fff',color:'#dc2626',border:'1px solid #fecaca',borderRadius:6,fontSize:12,fontWeight:700,cursor:'pointer'}}>
              취소
            </button>
          )}
        </div>
      </div>
    );
  };

  var renderBidCard=function(a){
    var myBid=a.myBid||{};
    var rank=myBid.myRank||0;
    var rankColor=rank===1?'#10b981':rank<=3?'#f59e0b':'#64748b';
    var totalBids=(a.liveStats&&a.liveStats.bidCount)||0;
    var highest=(a.liveStats&&a.liveStats.highestBid)||0;
    var modelLabel=(a.car&&a.car.model)||a.title||'경매';
    var isActive=a.status==='active';
    var bidStatusLabel=myBid.status==='winner'?'🏆 낙찰':myBid.status==='rejected'?'미낙찰':myBid.status==='cancelled'?'취소됨':'';
    return (
      <div key={a.id+'-'+(myBid.bidId||0)} style={{padding:'14px 16px',background:'#fff',border:'1px solid #e5e7eb',borderRadius:10,display:'flex',flexDirection:'column',gap:8}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:8}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:14,fontWeight:700,color:'#0f172a',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
              {modelLabel}
            </div>
            <div style={{fontSize:11,color:'#64748b',marginTop:3}}>
              내 입찰 <strong style={{color:'#1B3A5C'}}>{formatMan(myBid.amount)}만원</strong>
              {isActive&&rank>0&&<span style={{color:rankColor,fontWeight:700,marginLeft:6}}>· 현재 {rank}위 / {totalBids}명</span>}
              {isActive&&highest>0&&<span style={{marginLeft:6}}>· 최고 {formatMan(highest)}만원</span>}
            </div>
          </div>
          {bidStatusLabel?<span style={{padding:'3px 10px',background:myBid.status==='winner'?'#d1fae5':'#f1f5f9',color:myBid.status==='winner'?'#047857':'#64748b',borderRadius:4,fontSize:10,fontWeight:700}}>{bidStatusLabel}</span>:statusBadge(a.status)}
        </div>
        {isActive&&(
          <div style={{display:'flex',alignItems:'center',gap:6}}>
            <span style={{fontSize:11,color:'#64748b'}}>남은 시간</span>
            <AuctionCountdown timeRemaining={a.timeRemaining} size="sm"/>
          </div>
        )}
        <button onClick={function(){if(onViewAuction)onViewAuction(a.id)}}
          style={{padding:'8px 0',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:700,cursor:'pointer'}}>
          상세보기
        </button>
      </div>
    );
  };

  var renderFavoriteCard=function(a){
    var modelLabel=(a.car&&a.car.model)||a.title||'경매';
    var carNo=a.car&&a.car.number?a.car.number:'';
    var isActive=a.status==='active';
    var highestMan=formatMan((a.liveStats&&a.liveStats.highestBid)||0);
    var bidCount=(a.liveStats&&a.liveStats.bidCount)||0;
    var hasBids=bidCount>0;
    return (
      <div key={a.id} style={{padding:'14px 16px',background:'#fff',border:'1px solid #fecaca',borderRadius:10,display:'flex',flexDirection:'column',gap:8}}>
        <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:8}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:14,fontWeight:700,color:'#0f172a',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
              {modelLabel}{carNo?' · '+carNo:''}
            </div>
            <div style={{fontSize:11,color:'#64748b',marginTop:3}}>
              {hasBids?<span>현재 <strong style={{color:'#1B3A5C'}}>{highestMan}만원</strong></span>:<span style={{color:'#94a3b8'}}>아직 입찰 없음</span>}
              {' · 입찰 '+bidCount+'건'}
            </div>
          </div>
          {statusBadge(a.status)}
        </div>
        {isActive&&(
          <div style={{display:'flex',alignItems:'center',gap:6}}>
            <span style={{fontSize:11,color:'#64748b'}}>남은 시간</span>
            <AuctionCountdown timeRemaining={a.timeRemaining} size="sm"/>
          </div>
        )}
        <div style={{display:'flex',gap:6}}>
          <button onClick={function(){if(onViewAuction)onViewAuction(a.id)}}
            style={{flex:1,padding:'8px 0',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:700,cursor:'pointer'}}>
            상세보기
          </button>
          <button onClick={function(){unfavorite(a.id)}}
            style={{padding:'8px 14px',background:'#fff',color:'#ef4444',border:'1px solid #fecaca',borderRadius:6,fontSize:12,fontWeight:700,cursor:'pointer'}}>
            ♥ 해제
          </button>
        </div>
      </div>
    );
  };

  var renderWinCard=function(a){
    var modelLabel=(a.car&&a.car.model)||a.title||'경매';
    var seller=a.seller||{};
    var soldDate='';
    if(a.createdAt){
      try{soldDate=String(a.createdAt).slice(0,10).replace(/-/g,'.')}catch(e){}
    }
    return (
      <div key={a.id} style={{padding:'14px 16px',background:'#fff',border:'1px solid #d1fae5',borderRadius:10,display:'flex',flexDirection:'column',gap:8}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:8}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:14,fontWeight:700,color:'#0f172a',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
              {modelLabel}
            </div>
            <div style={{fontSize:11,color:'#64748b',marginTop:3}}>
              낙찰가 <strong style={{color:'#047857'}}>{formatMan(a.winAmount)}만원</strong>
              {soldDate&&' · '+soldDate}
            </div>
          </div>
          <span style={{padding:'3px 10px',background:'#d1fae5',color:'#047857',borderRadius:4,fontSize:10,fontWeight:700}}>✓ 낙찰</span>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:6,fontSize:11,color:'#64748b'}}>
          <span>출품자</span>
          <span style={{fontWeight:600,color:'#475569'}}>{seller.displayName||'출품업체'}</span>
          {seller.trustBadge&&<TrustBadge badge={seller.trustBadge} size="sm"/>}
        </div>
        <div style={{display:'flex',gap:6}}>
          <button onClick={function(){if(onViewAuction)onViewAuction(a.id)}}
            style={{flex:1,padding:'8px 0',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:700,cursor:'pointer'}}>
            상세보기
          </button>
          <button onClick={function(){setReviewAuction(a)}}
            style={{padding:'8px 14px',background:'#fff',color:'#1B3A5C',border:'1px solid #1B3A5C',borderRadius:6,fontSize:12,fontWeight:700,cursor:'pointer'}}>
            ⭐ 후기 작성
          </button>
        </div>
      </div>
    );
  };

  // ────────── 렌더 ──────────
  var SUB_TABS=[
    {key:'listings',label:'내 출품',icon:'📦'},
    {key:'bids',label:'내 입찰',icon:'🔨'},
    {key:'wins',label:'내 낙찰',icon:'🏆'},
    {key:'favorites',label:'즐겨찾기',icon:'♡'}
  ];

  var emptyMsg=subTab==='listings'?'아직 출품한 경매가 없습니다':subTab==='bids'?'아직 입찰한 경매가 없습니다':subTab==='wins'?'아직 낙찰 받은 경매가 없습니다':'즐겨찾기한 경매가 없습니다';
  var emptyIcon=subTab==='listings'?'📦':subTab==='bids'?'🔨':subTab==='wins'?'🏆':'♡';

  return (
    <div>
      {/* 서브탭 */}
      <div style={{display:'flex',gap:6,marginBottom:14,background:'#f1f5f9',padding:4,borderRadius:10}}>
        {SUB_TABS.map(function(t){
          var active=subTab===t.key;
          return (
            <button key={t.key} onClick={function(){setSubTab(t.key)}}
              style={{flex:1,padding:'10px 0',background:active?'#fff':'transparent',color:active?'#1B3A5C':'#64748b',border:'none',borderRadius:7,fontSize:12,fontWeight:active?800:600,cursor:'pointer',boxShadow:active?'0 2px 6px rgba(27,58,92,0.1)':'none',transition:'all 0.15s'}}>
              <span style={{marginRight:4}}>{t.icon}</span>{t.label}
            </button>
          );
        })}
      </div>

      {/* A-3b — 내 출품 탭에서만 성과 통계 카드 row */}
      {subTab==='listings'&&<SellerStatsRow/>}

      {/* 에러 */}
      {error&&!loading&&(
        <div style={{padding:'10px 12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,color:'#dc2626',fontSize:12,marginBottom:12}}>
          ⚠ {error}
        </div>
      )}

      {/* 로딩 스켈레톤 */}
      {loading&&(
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {[0,1,2].map(function(i){
            return (
              <div key={i} style={{padding:'14px 16px',background:'#fff',border:'1px solid #e5e7eb',borderRadius:10}}>
                <div style={{height:14,width:'60%',background:'#f1f5f9',borderRadius:4,marginBottom:8}}/>
                <div style={{height:10,width:'80%',background:'#f1f5f9',borderRadius:4,marginBottom:10}}/>
                <div style={{height:28,background:'#f1f5f9',borderRadius:6}}/>
              </div>
            );
          })}
        </div>
      )}

      {/* 빈 상태 */}
      {!loading&&!error&&items.length===0&&(
        <div style={{padding:'60px 20px',textAlign:'center',background:'#fff',borderRadius:12,border:'1px solid #e5e7eb'}}>
          <div style={{fontSize:56,marginBottom:14,opacity:0.4}}>{emptyIcon}</div>
          <div style={{fontSize:14,fontWeight:700,color:'#64748b'}}>{emptyMsg}</div>
        </div>
      )}

      {/* 목록 */}
      {!loading&&items.length>0&&(
        <div style={{display:'flex',flexDirection:'column',gap:10}}>
          {items.map(function(a){
            if(subTab==='listings')return renderListingCard(a);
            if(subTab==='bids')return renderBidCard(a);
            if(subTab==='wins')return renderWinCard(a);
            return renderFavoriteCard(a);
          })}
        </div>
      )}

      {/* 후기 작성 모달 */}
      {reviewAuction&&(
        <AuctionReviewModal auction={reviewAuction}
          onClose={function(){setReviewAuction(null)}}
          onSuccess={function(){setReviewAuction(null);loadData(subTab)}}/>
      )}

      {/* 경매 수정 모달 */}
      {editAuction&&(
        <AuctionEditModal auction={editAuction}
          onClose={function(){setEditAuction(null)}}
          onSuccess={function(){setEditAuction(null);loadData(subTab)}}/>
      )}

      {/* 취소 확인 모달 */}
      {cancelTarget&&(
        <div onClick={function(){if(!cancelSubmitting)setCancelTarget(null)}}
          style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9998,padding:16}}>
          <div onClick={function(e){e.stopPropagation()}}
            style={{background:'#fff',borderRadius:16,width:'100%',maxWidth:400,boxShadow:'0 20px 60px rgba(0,0,0,0.3)',padding:'22px'}}>
            <div style={{fontSize:16,fontWeight:800,color:'#dc2626',marginBottom:10,textAlign:'center'}}>
              경매 취소 확인
            </div>
            <div style={{padding:'10px 12px',background:'#f8fafc',borderRadius:8,marginBottom:12,fontSize:13,fontWeight:700,color:'#0f172a',textAlign:'center'}}>
              {cancelTarget.title}
            </div>
            {cancelTarget.bidCount>0?(
              <div style={{padding:'12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,fontSize:12,color:'#dc2626',marginBottom:14,lineHeight:1.6}}>
                ⚠ 이 경매에는 <strong>{cancelTarget.bidCount}건의 입찰</strong>이 있습니다.<br/>
                취소 시 <strong>신뢰도 페널티</strong>가 부과됩니다. 정말 취소하시겠습니까?
              </div>
            ):(
              <div style={{padding:'10px 12px',background:'#f8fafc',borderRadius:8,fontSize:12,color:'#64748b',marginBottom:14,textAlign:'center'}}>
                경매를 취소하면 목록에서 사라집니다.
              </div>
            )}
            {cancelError&&(
              <div style={{padding:'8px 10px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:6,fontSize:11,color:'#dc2626',marginBottom:12}}>
                {cancelError}
              </div>
            )}
            <div style={{display:'flex',gap:8}}>
              <button onClick={function(){if(!cancelSubmitting)setCancelTarget(null)}} disabled={cancelSubmitting}
                style={{flex:1,padding:'12px 0',background:'#f1f5f9',border:'1px solid #cbd5e1',borderRadius:8,fontSize:13,fontWeight:700,color:'#475569',cursor:cancelSubmitting?'wait':'pointer'}}>
                아니오
              </button>
              <button onClick={confirmCancel} disabled={cancelSubmitting}
                style={{flex:1,padding:'12px 0',background:cancelSubmitting?'#94a3b8':'#dc2626',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:800,cursor:cancelSubmitting?'wait':'pointer'}}>
                {cancelSubmitting?'처리 중...':'취소 확정'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/**
 * A-3b — 출품자 성과 통계 카드 row (내 출품 탭 상단).
 * GET /auctions/my-stats — counts + avgAmount + winRate + manner.
 * 출품 0건도 노출 (motivational baseline — manner 36.5).
 */
function SellerStatsRow(){
  var[stats,setStats]=useState(null);
  var[loading,setLoading]=useState(true);
  useEffect(function(){
    authFetch(API+'/auctions/my-stats').then(function(r){return r.json()}).then(function(d){
      setLoading(false);
      if(d&&d.success&&d.data)setStats(d.data);
    }).catch(function(){setLoading(false)});
  },[]);
  if(loading){
    return (
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8,marginBottom:14}}>
        {[0,1,2,3].map(function(i){
          return <div key={i} style={{height:74,background:'#f1f5f9',borderRadius:10}}/>;
        })}
      </div>
    );
  }
  if(!stats)return null;
  var lst=stats.listings||{};
  var win=stats.winners||{};
  var manner=stats.manner||{};
  var mannerTemp=manner.temperature!=null?Number(manner.temperature).toFixed(1):'36.5';
  var mannerColor=manner.temperature>=40?'#10b981':manner.temperature>=37?'#3b82f6':manner.temperature>=32?'#f59e0b':'#ef4444';
  var avgManwon=win.avgAmount?Math.round(win.avgAmount/10000).toLocaleString():'0';
  var winRate=stats.winRate!=null?Number(stats.winRate).toFixed(1)+'%':'—';
  return (
    <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8,marginBottom:14}}>
      <div style={{padding:'14px 12px',background:'#fff',border:'1px solid #e5e7eb',borderRadius:10,boxShadow:'0 1px 2px rgba(0,0,0,0.04)'}}>
        <div style={{fontSize:11,fontWeight:600,color:'#64748b',marginBottom:6}}>{'📦 출품'}</div>
        <div style={{fontSize:22,fontWeight:800,color:'#1B3A5C'}}>{lst.total||0}</div>
        <div style={{fontSize:10,color:'#94a3b8',marginTop:2}}>{(lst.active||0)+' active'}</div>
      </div>
      <div style={{padding:'14px 12px',background:'#fff',border:'1px solid #e5e7eb',borderRadius:10,boxShadow:'0 1px 2px rgba(0,0,0,0.04)'}}>
        <div style={{fontSize:11,fontWeight:600,color:'#64748b',marginBottom:6}}>{'🏆 낙찰'}</div>
        <div style={{fontSize:22,fontWeight:800,color:'#10b981'}}>{lst.sold||0}</div>
        <div style={{fontSize:10,color:'#94a3b8',marginTop:2}}>{'평균 '+avgManwon+'만원'}</div>
      </div>
      <div style={{padding:'14px 12px',background:'#fff',border:'1px solid #e5e7eb',borderRadius:10,boxShadow:'0 1px 2px rgba(0,0,0,0.04)'}}>
        <div style={{fontSize:11,fontWeight:600,color:'#64748b',marginBottom:6}}>{'📊 낙찰률'}</div>
        <div style={{fontSize:22,fontWeight:800,color:'#3b82f6'}}>{winRate}</div>
        <div style={{fontSize:10,color:'#94a3b8',marginTop:2}}>{'거절 '+(lst.rejectedAll||0)+' / 취소 '+(lst.cancelled||0)}</div>
      </div>
      <div style={{padding:'14px 12px',background:'#fff',border:'1px solid #e5e7eb',borderRadius:10,boxShadow:'0 1px 2px rgba(0,0,0,0.04)'}}>
        <div style={{fontSize:11,fontWeight:600,color:'#64748b',marginBottom:6}}>{'🌡️ 매너온도'}</div>
        <div style={{fontSize:22,fontWeight:800,color:mannerColor}}>{mannerTemp+'°'}</div>
        <div style={{fontSize:10,color:'#94a3b8',marginTop:2}}>{manner.level||'newbie'}{manner.warningCount>0?' · ⚠ '+manner.warningCount:''}</div>
      </div>
    </div>
  );
}

export default AuctionMyActivity;
